




import Component, { mixins } from "vue-class-component";
import MessagePreviewMixin from "./mixins/MessagePreviewMixin";
import { getMessagePreview } from "./views";

@Component({ name: "MessagePreview" })
export default class MessagePreview extends mixins(MessagePreviewMixin) {
  public get messagePreview() {
    return getMessagePreview(this.message);
  }
}
